import { PaymentMethodType } from '@nemuru-eng/js-api-client';

import { CreditCardPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/CreditCard/_shared/entities/PaymentMethodDetail/CreditCardPaymentMethodDetailEntity';
import { CreditCardPaymentMethod } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/CreditCard/CreditCardPaymentMethod';
import { BnplPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Bnpl/_shared/entities/PaymentMethodDetail/BnplPaymentMethodDetailEntity';
import { BnplPaymentMethod } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Bnpl/BnplPaymentMethod';
import { CardOnboardingPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/CardOnboarding/_shared/entities/PaymentMethodDetail/CardOnboardingPaymentMethodDetailEntity';
import { CardOnboardingPaymentMethod } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/CardOnboarding/CardOnboardingPaymentMethod';
import { CreditLinePaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/CreditLine/_shared/entities/PaymentMethodDetail/CreditLinePaymentMethodDetailEntity';
import { CreditLinePaymentMethod } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/CreditLine/CreditLinePaymentMethod';
import { LoanPaymentMethod } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/LoanPaymentMethod';
import { SinglePaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/SinglePayment/_shared/entities/PaymentMethodDetail/SinglePaymentMethodDetailEntity';
import { SinglePaymentMethod } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/SinglePayment/SinglePaymentMethod';

interface PaymentMethodFactoryProps {
  paymentMethodType: PaymentMethodType;
}

export const PaymentMethodFactory = ({ paymentMethodType }: PaymentMethodFactoryProps) => {
  if (SinglePaymentMethodDetailEntity.isAllowed(paymentMethodType)) {
    return <SinglePaymentMethod paymentMethodType={paymentMethodType} />;
  }

  if (BnplPaymentMethodDetailEntity.isAllowed(paymentMethodType)) {
    return <BnplPaymentMethod paymentMethodType={paymentMethodType} />;
  }

  if (CardOnboardingPaymentMethodDetailEntity.isAllowed(paymentMethodType)) {
    return <CardOnboardingPaymentMethod paymentMethodType={paymentMethodType} />;
  }

  if (CreditLinePaymentMethodDetailEntity.isAllowed(paymentMethodType)) {
    return <CreditLinePaymentMethod paymentMethodType={paymentMethodType} />;
  }

  if (CreditCardPaymentMethodDetailEntity.isAllowed(paymentMethodType)) {
    return <CreditCardPaymentMethod paymentMethodType={paymentMethodType} />;
  }

  return <LoanPaymentMethod paymentMethodType={paymentMethodType} />;
};
